import Links from '../../controllers/links';

export default instance => {
  instance.attachEvent('onLinkClick', (id, event) => {
    Links.onLinkClick(id);
  });
};
